import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { ApiEndpoint } from 'app/agriculture/queries/apiEndpoints';
import { getFarm } from 'app/agriculture/queries/farms/getFarm';

export function useFarmQuery({ farmId }: { farmId: number }) {
    const { data } = useSuspenseQuery(
        queryOptions({ queryKey: [`${ApiEndpoint.farms}${farmId}/`], queryFn: getFarm }),
    );

    return data;
}
